import { Helmet } from "react-helmet-async";

const SITE_URL = "https://vacationspro.com"; // Update if your domain differs
const DEFAULT_OG_IMAGE = `${SITE_URL}/logo.png`;

export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  noindex = false,
  schema = null,
}) {
  const fullTitle = title?.includes("Vacations Pro") ? title : `${title} | Vacations Pro`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Vacations Pro" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* One TravelAgency record per page (the page shell carries none) */}
      <script type="application/ld+json">{JSON.stringify(LOCAL_BUSINESS_SCHEMA)}</script>
      {schema && schema !== LOCAL_BUSINESS_SCHEMA && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}

export const COMPANY = {
  legalName: "Vacations Pro International Private Limited",
  founded: "2014",
  addressLines: ["Office 701, 7th Floor, K-10 Tower, behind Federal Bank,", "Feroze Gandhi Market, Ludhiana, Punjab 141001"],
  addressInline: "Office 701, 7th Floor, K-10 Tower, behind Federal Bank, Feroze Gandhi Market, Ludhiana, Punjab 141001",
  phones: [
    { display: "+91 95010 30117", tel: "+919501030117" },
    { display: "+91 78883 70003", tel: "+917888370003" },
  ],
  email: "alerts@vacationspro.com",
  reviewCount: "264",
  rating: "4.8",
};

// Reusable schemas
export const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  "name": COMPANY.legalName,
  "foundingDate": COMPANY.founded,
  "description": "Customized honeymoon and family holiday planner serving travellers across India and abroad. Founded in 2014.",
  "url": SITE_URL,
  "logo": `${SITE_URL}/logo.png`,
  "image": `${SITE_URL}/logo.png`,
  "telephone": COMPANY.phones.map((p) => p.tel),
  "email": COMPANY.email,
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office 701, 7th Floor, K-10 Tower, behind Federal Bank, Feroze Gandhi Market",
    "addressLocality": "Ludhiana",
    "addressRegion": "Punjab",
    "postalCode": "141001",
    "addressCountry": "IN"
  },
  "areaServed": [{ "@type": "Country", "name": "India" }, "Worldwide"],
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      "opens": "08:45",
      "closes": "19:15"
    }
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": COMPANY.rating,
    "reviewCount": COMPANY.reviewCount,
    "bestRating": "5"
  },
  "priceRange": "₹₹",
  "sameAs": [
    "https://www.facebook.com/vacationspro/",
    "https://www.instagram.com/vacationsproofficial"
  ]
};
